import { render, staticRenderFns } from "./DialogCadastroUsuario.vue?vue&type=template&id=f80bf100&scoped=true&"
import script from "./DialogCadastroUsuario.vue?vue&type=script&lang=js&"
export * from "./DialogCadastroUsuario.vue?vue&type=script&lang=js&"
import style0 from "./DialogCadastroUsuario.vue?vue&type=style&index=0&id=f80bf100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80bf100",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VForm,VLayout,VSpacer,VTextField})
